import React from "react";

export default function NextItems({ showNextItems, scrollIndicatorHeightClass }) {

  return (
    <div className={`d-none d-sm-block next-items-container ${scrollIndicatorHeightClass}`} onClick={showNextItems}>
      <span className="fas fa-chevron-right next-items" />
    </div>
  );
}